import { useEffect, useState } from 'react';

import { isStorageMediaUrl, resolveStorageMediaUrl } from '@/services/storage-media-service';
import { useBrowserQueryCache } from '@/lib/query-cache/use-browser-query-cache';

type MediaUrlState =
  | { status: 'idle'; resolvedUrl?: undefined; error?: undefined }
  | { status: 'loading'; resolvedUrl?: undefined; error?: undefined }
  | { status: 'success'; resolvedUrl: string; error?: undefined }
  | { status: 'error'; resolvedUrl?: undefined; error: string };

export function useResolvedMediaUrl(url: string | null | undefined): MediaUrlState {
  const queryCache = useBrowserQueryCache();
  const [state, setState] = useState<MediaUrlState>(() => {
    if (!url) {
      return { status: 'idle' };
    }

    if (!isStorageMediaUrl(url)) {
      return { status: 'success', resolvedUrl: url };
    }

    return { status: 'loading' };
  });

  useEffect(() => {
    if (!url) {
      setState({ status: 'idle' });
      return;
    }

    if (!isStorageMediaUrl(url)) {
      setState({ status: 'success', resolvedUrl: url });
      return;
    }

    let active = true;

    setState({ status: 'loading' });

    resolveStorageMediaUrl(url, { cache: queryCache })
      .then((resolvedUrl) => {
        if (!active) {
          return;
        }

        setState({ status: 'success', resolvedUrl });
      })
      .catch((error) => {
        console.error('useResolvedMediaUrl failed', { url, error });

        if (!active) {
          return;
        }

        setState({
          status: 'error',
          error: 'Não foi possível carregar esta mídia agora.',
        });
      });

    return () => {
      active = false;
    };
  }, [queryCache, url]);

  return state;
}
